// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y2v1","rootMobile":"styles_rootMobile__biELR"};